﻿import React, { useRef } from 'react';
import { Overlay2 } from '@blueprintjs/core';
import PropTypes from 'prop-types';

import { HelperFunctions } from 'helpers';
import { ShowHide } from '../layout';
import './Notifications.css';

export function MediaViewer(
    {
        onClose = null,
        mediaType = "video/mp4",
        isOpen,
        mediaSource,
        videoStyle
    }
) {
    const containerRef = useRef(null);

    function handleClose(e) {
        HelperFunctions.executeIfNotNull(onClose);
    }

    return (
        <Overlay2 isOpen={isOpen} onClose={handleClose} portalClassName="media-player-overlay" childRef={containerRef}>
            <div ref={containerRef} className="bp6-dialog-container">
                <div className="media-player">
                    <ShowHide
                        evaluator={mediaSource != null}
                        show={(
                          <video
                            autoPlay
                            controls
                            {...(videoStyle && { style: videoStyle })}
                            >
                                <source src={mediaSource} type={mediaType} />
                            </video>
                        )}
                    />
                </div>
            </div>
        </Overlay2>
    );
}

MediaViewer.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    mediaSource: PropTypes.string,
    mediaType: PropTypes.string,
    onClose: PropTypes.func,
    videoStyle: PropTypes.object,
};